<template>
  <div style="padding-top:-2px;margin-top:-2px;">
    <v-label><b>{{ label }}</b></v-label>
    <v-autocomplete
      v-model="localValue"
      :items="items"
      :item-value="itemvalue"
      :item-text="itemtext"
      :return-object="returnObject"
      :disabled="disabled"
      :readonly="readonly"
      :clearable="clearable"
      dense
      outlined
      @input="updateValue"
      hide-details="false"
    />
  </div>
</template>
  <!-- Usa v-model aquí -->
<script>
  import CreationPeriods from '../../services/HumanResource/CreationPeriods';
  export default {
    name: "SPeriods",
    props: {
      value: null,
      // ID del periodo a preseleccionar (útil cuando el padre solo tiene el ID)
      valueId: {
        type: [Number, String],
        default: null,
      },
      year: {
        type: Number,
        default: 0,
      },
      type: {
        type: Number,
        default: 0,
      },
      label: {
        type: String,
        default: "Periodo",
      },
      itemtext: {
        type: String,
        default: "PdsName",
      },
      itemvalue: {
        type: String,
        default: "PdsID",
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      returnObject: {
        type: Boolean,
        default: false,
      },
      clearable: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        localValue: this.value,
        items: [],
      };
    },
    watch: {
      value(newValue) {
        // Acepta tanto objeto completo como ID primitivo
        if (newValue == null) {
          this.localValue = null;
          return;
        }
        if (this.returnObject) {
          if (typeof newValue === 'object') {
            this.localValue = newValue;
          } else {
            // Si llega un ID, mapeamos al objeto del listado
            this.setLocalValueById(newValue);
          }
        } else {
          this.localValue = newValue;
        }
      },
      valueId() {
        this.syncInitialSelection();
      },
      year() {
        this.load();
      },
      type() {
        this.load();
      }
    },
    mounted() {
      this.load();
    },
    methods: {
      updateValue(value) {
        this.localValue = value;
        this.$emit("input", value);
      },
      setLocalValueById(id) {
        if (!this.items || !this.items.length) return;
        const key = this.itemvalue || 'PdsID';
        const found = this.items.find(it => String(it[key]) === String(id));
        if (found) {
          this.localValue = this.returnObject ? found : found[key];
          this.$emit('input', this.localValue);
        }
      },
      syncInitialSelection() {
        // Preselección al cargar: prioridad value (si viene como objeto o id), luego valueId
        if (this.value != null) {
          if (this.returnObject && typeof this.value !== 'object') {
            this.setLocalValueById(this.value);
          } else {
            this.localValue = this.value;
          }
        } else if (this.valueId != null) {
          this.setLocalValueById(this.valueId);
        }
      },
      load() {
        CreationPeriods.list(this.type, this.year, this.$fun.getUserID())
            .then((r) => {
                this.items = r.data;
                // Sincroniza la selección inicial tras cargar los items
                this.syncInitialSelection();
            })
      },
    },
  };
  </script>
  